import { CardContent } from '@mui/material';
import { CloudAccountType } from '@repo/api-gw-sdk';

import { PanelWrapper } from '@/components/panels/panelWrapper';

import { CreateAWSAccountPanel } from './createAWSAccountPanel';

export const CreateAwsCloudAccount = ({
  accountType,
  onCreated,
  onClose,
}: {
  accountType: CloudAccountType;
  onCreated: (accountId: string) => void;
  onClose: () => void;
}) => {
  const headerTitle =
    accountType === CloudAccountType.Source
      ? `Connect ${accountType.toLowerCase()}`
      : `Connect ${accountType.toLowerCase()} account`;

  return (
    <PanelWrapper rounded header={{ title: headerTitle, onClose }}>
      <CardContent>
        <CreateAWSAccountPanel
          accountType={accountType}
          onCreated={onCreated}
        />
      </CardContent>
    </PanelWrapper>
  );
};
